import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material"
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import HomeIcon from "@mui/icons-material/Home";
import MenuIcon from '@mui/icons-material/Menu';

import LoadingButton from '@mui/lab/LoadingButton';
import CachedIcon from '@mui/icons-material/Cached';


import { useNavigate } from "react-router-dom";
import AccountCircle from "@mui/icons-material/AccountCircle";
import PowerSettingsNewOutlinedIcon from '@mui/icons-material/PowerSettingsNewOutlined';

import { tokens } from '../../theme'
import { logOffUser } from '../../store/user/user.action'
import { useDispatch } from 'react-redux'

import { signOutUser } from '../../utils/firebase/firebase'

import { useSelector } from "react-redux";
import { selectCurrentUser, selectIsAdminUser, selectIsOfficeStaffUser } from "../../store/user/user.selector";
import { useState, useEffect } from "react"

import { useLocation } from "react-router-dom";

import { Box, TextField, CircularProgress, InputAdornment, Modal } from "@mui/material";
import Swal from 'sweetalert2'
import { djangoApi } from "../../utils/axios/axios.utils";
import CloseIcon from '@mui/icons-material/Close'; // ou DeleteIcon
import CameraAltIcon from '@mui/icons-material/CameraAlt';

const ButtonAppBar = ({ toggleDrawer, open }) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	const isAdmin = useSelector(selectIsAdminUser);
	const isOfficeStaf = useSelector(selectIsOfficeStaffUser)
	const user = useSelector(selectCurrentUser);
	const [loadingPage, setLoadingPage] = useState(false);
	const [showBar, setShowBar] = useState(true);

	const { pathname } = useLocation();

	const navigate = useNavigate();
	const dispatch = useDispatch();

	const [searchQuery, setSearchQuery] = useState("");
	const [isLoadingInfo, setIsLoadingInfo] = useState(false);
	const [modalOpen, setModalOpen] = useState(false)
	const [modalImage, setModalImage] = useState(null)

	useEffect(() => {
		if (pathname && pathname === '/vendedoras/contrato') {
			setShowBar(false)
		} else {
			setShowBar(true)
		}
	}, [pathname]);

	const handlerHomeNav = () => {
		navigate("/");
	};


	const handlerLogout = () => {
		dispatch(logOffUser())
		signOutUser()
		console.log('log out')
	}

	const handlerRefreshPage = () => {
		setLoadingPage(true);
		setTimeout(() => {
			window.location.reload(true);
		}, 1000)
	}

	const getSellerSelsInfo = async (value) => {
		setIsLoadingInfo(true)
		const showMissing = false
		console.log('shoingsimissi', showMissing)
		try {
			const res = await djangoApi
				.get(`products/register_prods/${value}/get_list_kits_prods_sellers_in/?show_missing=${showMissing}`, {
					headers: {
						Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
						"Content-Type": "application/json"
					}
				})
			const { data, status } = res
			if (status === 200) {
				// setDataUser(data.data)
				// console.log('data here: ', data)
				if (!data.data.prod) {
					Swal.fire({
						icon: 'error',
						title: 'Produto não encontrado!!',
						text: `O Produto ${value} não está cadastrado.`,
						confirmButtonColor: '#d33',
						confirmButtonText: 'Ok',
					});
					return
				}
				setModalImage(data.data.prod?.imageUrl || '/sem-produto.jpg');
				setModalOpen(true);
				setSearchQuery("")
			}
			return
		} catch (err) {
			console.log("Erro consultar o produto:", searchQuery, err);
			window.alert(err);
			setIsLoadingInfo(false)
		} finally {
			// pass
			setIsLoadingInfo(false)
		}
	};

	const handleSearch = (value) => {
		const normalizedValue = value.toUpperCase();

		setSearchQuery(normalizedValue);

		if (normalizedValue.length === 6) {
			console.log("value", normalizedValue);
			getSellerSelsInfo(normalizedValue);
		}
	};
	if (!showBar) {
		return
	}

	return (
		<>
			<Modal open={modalOpen} onClose={() => setModalOpen(false)}>
				<Box
					sx={{
						position: 'fixed',
						top: 0,
						left: 0,
						width: '100vw',
						height: '100vh',
						bgcolor: 'rgba(0,0,0,0.9)',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						zIndex: 9999,
					}}
				>
					<IconButton
						onClick={() => setModalOpen(false)}
						sx={{
							position: 'absolute',
							top: 16,
							right: 16,
							color: 'white',
							backgroundColor: 'rgba(255,255,255,0.1)',
							'&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' },
						}}
					>
						<CloseIcon fontSize="large" />
					</IconButton>

					<Box
						component="img"
						src={modalImage}
						onError={(e) => {
							e.currentTarget.onerror = null;
							e.currentTarget.src = '/sem-produto.jpg';
						}}
						alt="Imagem produto"
						sx={{
							maxWidth: '90vw',
							maxHeight: '90vh',
							objectFit: 'contain',
							borderRadius: 2,
							boxShadow: 6,
						}}
					/>
				</Box>
			</Modal>
			<AppBar position="fixed" sx={{
				backgroundColor: colors.pink[800],
				borderTop: 'none',
				minHeight: '30px',
				height: '50px'
			}}>
				<Toolbar
					sx={{ minHeight: '50px !important' }}
				>
					{
						isAdmin || isOfficeStaf ?
							<>

								<IconButton
									size="small"
									edge="start"
									color="inherit"
									aria-label="menu"
									sx={{ mr: 2 }}
									onClick={
										toggleDrawer(true)
									}
								>
									<MenuIcon sx={{ fontSize: '20px' }} />
								</IconButton>
							</>
							:
							<IconButton
								size="small"
								edge="start"
								color="inherit"
								aria-label="menu"
								sx={{ mr: 2 }}
								onClick={() => {
									handlerHomeNav();
								}}
							>
								<HomeIcon sx={{ fontSize: '30px' }} />
							</IconButton>


					}

					{

						(isAdmin || isOfficeStaf) &&
						<>
							<IconButton>
								<CameraAltIcon />
							</IconButton>
							<TextField
								variant="standard"
								placeholder="Consulte ID Foto"
								value={searchQuery}
								onChange={(e) => handleSearch(e.target.value)}
								inputProps={{ maxLength: 6 }}
								disabled={isLoadingInfo}
								// inputRef={inputRef}
								InputProps={{
									endAdornment: (
										isLoadingInfo ? (
											<InputAdornment position="end">
												<CircularProgress size={16} color="inherit" sx={{ marginBottom: '6px' }} />
											</InputAdornment>
										) : null
									),
								}}
								sx={{
									width: "100px",
									marginRight: "10px",
									'& .MuiInput-underline:before': {
										borderBottomColor: 'whitesmoke',
									},
									'& .MuiInput-underline:hover:before': {
										borderBottomColor: 'rgba(153,153,153,0.2)',
									},
									'& .MuiInput-underline:after': {
										borderBottomColor: 'rgba(204,204,204,0.5)',
									},
								}}
							/>
						</>
					}
					<Typography variant="h6" component="div" sx={{ flexGrow: 1 }} />
					<IconButton
						size="small"
						edge="start"
						color="success"
						aria-label="menu"
						sx={{ mr: 2 }}
						onClick={() => {
							handlerRefreshPage();
						}}
					>
						{
							loadingPage ?
								<CachedIcon
									sx={{
										fontSize: '20px',
										animation: "spin 1.7s linear infinite",
										"@keyframes spin": {
											"0%": {
												transform: "rotate(360deg)",
											},
											"100%": {
												transform: "rotate(0deg)",
											},
										},
									}}
								/>
								:
								<CachedIcon sx={{ fontSize: '20px' }} />
						}
					</IconButton>

					{user?.displayName ? user.displayName : 'Usuário'}
					<IconButton
						aria-label="account of current user"
						aria-controls="menu-appbar"
						aria-haspopup="true"
						// onClick={handleMenu}
						color={!isAdmin ? 'info' : 'secondary'}
					>
						<AccountCircle sx={{ fontSize: '20px' }} />
					</IconButton>
					<IconButton onClick={handlerLogout}>
						<PowerSettingsNewOutlinedIcon style={{ color: colors.redAccent[500], fontSize: '20px' }} />
					</IconButton>
				</Toolbar>
			</AppBar>
		</>

	);
};

export default ButtonAppBar;
